import { Component, Vue } from 'vue-property-decorator';
import { EColorState } from "@/components/IBPayment/interface";

@Component
export default class IBPaymentCardColor extends Vue {

	classNameByColor: any = {
		success: '_green',
		danger: '_red',
		info: '_gray',
		warning: '_orange',
	}

	classNameByBackgroundColor: any = {
		success: '_green-background',
		danger: '_red-background',
		info: '_gray-background',
		warning: '_orange-background',
	}

	getClassNameByColor(v?: EColorState): string {
		return (v && this.classNameByColor[v]) || '';
	}

	getClassNameByBackgroundColor(v?: EColorState): string {
		return (v && this.classNameByBackgroundColor[v]) || '';
	}

}